<section class="flex h-full">
  @if (sidebarOpen$ | async) {
  <!-- Scrim: a real <button> so the dismiss gesture is a native control, not a div with a click
       handler. aria-hidden + tabindex="-1" keep it out of the a11y tree and the tab order -
       keyboard users dismiss with Escape (see LayoutComponent.onEscape). -->
  <button
    type="button"
    class="fixed inset-0 z-40 bg-functional-overlay lg:hidden"
    aria-hidden="true"
    tabindex="-1"
    (click)="closeSidebar()"></button>
  }

  <app-sidebar></app-sidebar>

  <!-- Main Content -->
  <div
    class="relative flex min-h-0 min-w-0 flex-1 flex-col bg-neutral-white"
    [attr.inert]="(sidebarModal$ | async) ? '' : null">
    <app-header
      [title]="pageTitle"
      [subtitle]="pageSubtitle"
      [buttons]="pageButtons"
      [showBackButton]="showBackButton"
      [sidebarOpen]="(sidebarOpen$ | async) ?? false"
      (menuClick)="toggleSidebar()"
      (backClick)="goBack()" />
    <main class="relative min-h-0 flex-1 overflow-y-auto p-4 sm:p-6">
      <router-outlet></router-outlet>
    </main>
  </div>
</section>
